<template>
  <div>
    <el-drawer :visible.sync="drawer" custom-class="drawer-wrap-detail" direction="rtl" :before-close="closeDrawer">
      <template v-if="drawer">
        <div class="drawer_header">
          <div>
            <el-tooltip v-if="form.companyName&&form.companyName.length > 20" class="item" effect="dark" :content="form.companyName" placement="top">
              <b>{{ getCompanyName(form.companyName) }}</b>
            </el-tooltip>
            <b v-else>{{ getCompanyName(form.companyName) }}</b>
            <el-tooltip v-if="form.name&&form.name.length > 10" class="item" effect="dark" :content="form.name" placement="top">
              <span>{{ getName(form.name) }}</span>
            </el-tooltip>
            <span v-else>{{ getName(form.name) }}</span>
            <img v-if="CallPermissionBtn('90001')" @click="handleClickCall" style="cursor: pointer;" src="@/assets/call/phone-icon.png" alt="">
          </div>
          <div>
            <el-button v-if="form.leadState !== 5&&form.leadState !== 0&&form.leadState !== 4" size="small" type="primary" @click="clickFollow">添加跟进</el-button>
            <el-button v-if="form.leadState !== 5 && detailType" size="small" type="primary" @click="clickAllot">分配名单</el-button>
            <el-button v-if="form.leadState === 4" size="small" type="primary" @click="clickActivate">激活名单</el-button>
          </div>
          <p>
            <span>名单状态</span>
            <play-status type="violet" v-if="form.leadState === 0">待分配</play-status>
            <play-status type="primary" v-if="form.leadState === 1">待联系</play-status>
            <play-status type="error" v-if="form.leadState === 2">未接通</play-status>
            <play-status type="warning" v-if="form.leadState === 3">待定</play-status>
            <play-status type="disabled" v-if="form.leadState === 4">已关闭</play-status>
            <play-status type="green" v-if="form.leadState === 5">已转线索</play-status>
            <span v-if="rowData.leadState !== 0">归属人</span>
            <em v-if="rowData.leadState !== 0">{{ form.ownerName||'--' }}</em>
          </p>
        </div>
        <div class="drawer_body">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="名单详情" name="first">
              <el-form ref="form" :model="form" label-width="100px">
                <div class="drawer_content">
                  <h2>基本信息</h2>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="公司名称">
                        <el-input ref="companyName" v-if="editKey === 'companyName'" maxlength="50" @blur="changeForm" v-model.trim="form.companyName" placeholder="请输入公司名称" size="small"></el-input>
                        <template v-else>
                          <el-tooltip v-if="form.companyName" class="item" effect="dark" :content="form.companyName" placement="top">
                            <span class="span-edit">{{ form.companyName }}</span>
                          </el-tooltip>
                          <span v-else class="span-edit">--</span>
                          <img @click="clickIsEdit('companyName')" class="img-edit" src="~@/assets/call/edit.png" alt="">
                        </template>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系人姓名">
                        <el-input ref="name" v-if="editKey === 'name'" maxlength="20" @blur="changeForm" v-model.trim="form.name" placeholder="请输入联系人姓名" size="small"></el-input>
                        <template v-else>
                          <el-tooltip v-if="form.name" class="item" effect="dark" :content="form.name" placement="top">
                            <span class="span-edit">{{ form.name }}</span>
                          </el-tooltip>
                          <span v-else class="span-edit">--</span>
                          <img @click="clickIsEdit('name')" class="img-edit" src="~@/assets/call/edit.png" alt="">
                        </template>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="公司所在区域">
                        <el-cascader size="small" ref="cascader" filterable @change="changeForm" :props="{ checkStrictly: true }" v-model="form.companyRegion" :options="areaData" clearable
                          placeholder="请选择公司所在区域" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系人手机">
                        <el-input ref="mobilePhone" v-if="editKey === 'mobilePhone'" maxlength="11" @blur="changeForm" @input="form.mobilePhone=form.mobilePhone.replace(/[^\d]/g,'')"
                          v-model.trim="form.mobilePhone" placeholder="请输入联系人手机" size="small"></el-input>
                        <template v-else>
                          <span class="span-edit">{{ form.mobilePhone||'--' }}</span>
                          <img @click="clickIsEdit('mobilePhone')" class="img-edit" src="~@/assets/call/edit.png" alt="">
                        </template>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="公司地址">
                        <el-input ref="address" v-if="editKey === 'address'" maxlength="100" @blur="changeForm" v-model.trim="form.address" placeholder="请输入公司地址" size="small"></el-input>
                        <template v-else>
                          <el-tooltip v-if="form.address" class="item" effect="dark" :content="form.address" placement="top">
                            <span class="span-edit">{{ form.address }}</span>
                          </el-tooltip>
                          <span v-else class="span-edit">--</span>
                          <img @click="clickIsEdit('address')" class="img-edit" src="~@/assets/call/edit.png" alt="">
                        </template>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="手机归属地">
                        <span class="span-edit">{{ form.provinceCity||'--' }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="团队规模">
                        <!-- <el-input ref="teamSize" v-if="editKey === 'teamSize'" @blur="changeForm" v-model="form.teamSize" placeholder="请输入团队规模" size="small"></el-input>
                        <template v-else>
                          <el-tooltip v-if="form.teamSize" class="item" effect="dark" :content="form.teamSize" placement="top">
                            <span class="span-edit">{{ form.teamSize }}</span>
                          </el-tooltip>
                          <span v-else class="span-edit">--</span>
                          <img @click="clickIsEdit('teamSize')" class="img-edit" src="~@/assets/call/edit.png" alt="">
                        </template> -->
                        <el-select size="small" v-model="form.teamSize" @change="changeForm" placeholder="请选择团队规模" clearable>
                          <el-option v-for="(item,index) in employeeCountList" :key="index" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="自动定位城市">
                        <span class="span-edit">{{ form.location||'--' }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="所属行业">
                        <el-select v-model="form.industry" @change="changeForm" size="small" placeholder="请选择所属行业">
                          <el-option v-for="(item,index) in industryList" :key="index" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="来源渠道">
                        <span class="span-edit">{{ form.clueSource||'--' }}</span>
                      </el-form-item>
                    </el-col>
                    <div v-for="(item,key,index) in form.remarkDict" :key="index">
                      <!-- 线索传到呼叫中心之后表单字段过滤掉公司名称字段 -->
                      <el-col :span="12" class="item-max"  v-if="key!=='公司名称'">
                        <el-form-item>
                          <el-tooltip v-if="key.length > 6" slot="label" class="item" effect="dark" :content="key" placement="top">
                            <span>{{ key }}</span>
                          </el-tooltip>
                          <span v-else slot="label">{{ key }}</span>
                          <el-input :ref="'demand'+index" v-if="editKey === 'demand'+index" @blur="changeForm" v-model.trim="form.remarkDict[key]" placeholder="请输入客户需求" size="small"></el-input>
                          <template v-else>
                            <el-tooltip v-if="form.remarkDict[key]" class="item" effect="dark" :content="form.remarkDict[key]" placement="top">
                              <span class="span-edit">{{ form.remarkDict[key] }}</span>
                            </el-tooltip>
                            <span v-else class="span-edit">--</span>
                            <img @click="clickIsEdit('demand'+index)" class="img-edit" src="~@/assets/call/edit.png" alt="">
                          </template>
                        </el-form-item>
                      </el-col>
                    </div>

                  </el-row>
                </div>
                <div class="drawer_content mt-16">
                  <h2>详细信息</h2>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="联系人电话">
                        <el-input ref="telephone" v-if="editKey === 'telephone'" maxlength="12" @blur="changeForm" v-model.trim="form.telephone" placeholder="请输入联系人电话" size="small"></el-input>
                        <template v-else>
                          <span class="span-edit">{{ form.telephone||'--' }}</span>
                          <img @click="clickIsEdit('telephone')" class="img-edit" src="~@/assets/call/edit.png" alt="">
                        </template>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系人性别">
                        <el-radio-group v-model="form.gender" size="small" @change="changeForm">
                          <el-radio :label="0">未知</el-radio>
                          <el-radio :label="1">先生</el-radio>
                          <el-radio :label="2">女士</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系人角色">
                        <el-select v-model="form.role" @change="changeForm" size="small" placeholder="请选择联系人角色">
                          <el-option v-for="(item,index) in roleList" :key="index" :label="item.title" :value="item.code"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系人部门">
                        <el-input ref="department" v-if="editKey === 'department'" @blur="changeForm" size="small" maxlength="20" v-model.trim="form.department" placeholder="请填写联系人部门" />
                        <template v-else>
                          <el-tooltip v-if="form.department" class="item" effect="dark" :content="form.department" placement="top">
                            <span class="span-edit">{{ form.department }}</span>
                          </el-tooltip>
                          <span v-else class="span-edit">{{ form.department||'--' }}</span>
                          <img @click="clickIsEdit('department')" class="img-edit" src="~@/assets/call/edit.png" alt="">
                        </template>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系人职位">
                        <el-input ref="position" v-if="editKey === 'position'" maxlength="20" @blur="changeForm" v-model.trim="form.position" placeholder="请输入联系人职位" size="small"></el-input>
                        <template v-else>
                          <el-tooltip v-if="form.position" class="item" effect="dark" :content="form.position" placement="top">
                            <span class="span-edit">{{ form.position }}</span>
                          </el-tooltip>
                          <span v-else class="span-edit">--</span>
                          <img @click="clickIsEdit('position')" class="img-edit" src="~@/assets/call/edit.png" alt="">
                        </template>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系人微信号">
                        <el-input ref="weixin" v-if="editKey === 'weixin'" maxlength="20" @blur="changeForm" v-model.trim="form.weixin" placeholder="请输入联系人微信号" size="small"></el-input>
                        <template v-else>
                          <el-tooltip v-if="form.weixin" class="item" effect="dark" :content="form.weixin" placement="top">
                            <span class="span-edit">{{ form.weixin }}</span>
                          </el-tooltip>
                          <span v-else class="span-edit">--</span>
                          <img @click="clickIsEdit('weixin')" class="img-edit" src="~@/assets/call/edit.png" alt="">
                        </template>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系人QQ">
                        <el-input ref="qq" v-if="editKey === 'qq'" maxlength="20" @blur="changeForm" v-model.trim="form.qq" placeholder="请输入联系人QQ" size="small"></el-input>
                        <template v-else>
                          <el-tooltip v-if="form.qq" class="item" effect="dark" :content="form.qq" placement="top">
                            <span class="span-edit">{{ form.qq }}</span>
                          </el-tooltip>
                          <span v-else class="span-edit">--</span>
                          <img @click="clickIsEdit('qq')" class="img-edit" src="~@/assets/call/edit.png" alt="">
                        </template>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系人邮箱">
                        <el-input ref="email" v-if="editKey === 'email'"  maxlength="50" @blur="changeForm" v-model.trim="form.email" placeholder="请输入联系人邮箱" size="small"></el-input>
                        <template v-else>
                          <el-tooltip v-if="form.email" class="item" effect="dark" :content="form.email" placement="top">
                            <span class="span-edit">{{ form.email }}</span>
                          </el-tooltip>
                          <span v-else class="span-edit">--</span>
                          <img @click="clickIsEdit('email')" class="img-edit" src="~@/assets/call/edit.png" alt="">
                        </template>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系人年龄">
                        <el-input ref="age" v-if="editKey === 'age'" maxlength="3" @blur="changeForm" @input="form.age=form.age.replace(/[^\d]/g,'')" v-model="form.age" placeholder="请输入联系人年龄"
                          size="small"></el-input>
                        <template v-else>
                          <span class="span-edit">{{ form.age||'--'  }}</span>
                          <img @click="clickIsEdit('age')" class="img-edit" src="~@/assets/call/edit.png" alt="">
                        </template>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系人备注">
                        <el-input ref="remark" v-if="editKey === 'remark'" maxlength="1000" @blur="changeForm" v-model.trim="form.remark" placeholder="请输入联系人备注" size="small"></el-input>
                        <template v-else>
                          <el-tooltip v-if="form.remark" class="item" effect="dark" :content="form.remark" placement="top">
                            <span class="span-edit">{{ form.remark }}</span>
                          </el-tooltip>
                          <span v-else class="span-edit">--</span>
                          <img @click="clickIsEdit('remark')" class="img-edit" src="~@/assets/call/edit.png" alt="">
                        </template>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系人生日">
                        <el-date-picker v-model="form.birthday" @change="changeForm" :picker-options="pickerOptionsTime" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                          placeholder="请选择联系人生日" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <div class="drawer_content mt-16">
                  <h2>系统信息</h2>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="名单编号">
                        <span class="span-edit">{{ form.leadNo||'--' }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="创建日期">
                        <span class="span-edit">{{ form.createAt||'--' }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="创建人员">
                        <span class="span-edit">{{ form.createByName||'--' }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="最后修改日期">
                        <span class="span-edit">{{ form.updateAt||'--' }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="最后修改人员">
                        <span class="span-edit">{{ form.updateByName||'--' }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="跟进记录" name="second"></el-tab-pane>
            <el-tab-pane label="通话记录" name="third"></el-tab-pane>
          </el-tabs>
          <div class="drawer_followUp" v-if="activeName !== 'first'">
            <div class="tac mt-20 mb-20" v-if="!dataList.length">暂无数据</div>
            <div class="followUp_list" v-for="(item,index) in dataList" :key="activeName+index">
              <p>{{ item.formatTime }}</p>
              <div class="followUp_content">
                <el-row class="followUp_title">
                  <el-col :span="18" class="tal">
                    <img v-if="item.staffInfo&&item.staffInfo.avatar" :src="item.staffInfo.avatar" alt="">
                    <img v-else src="~@/assets/navtop_imgs/headportrait.png" alt="">
                    <b v-if="item.staffInfo">{{ item.staffInfo.userName }}（{{ item.staffInfo.departmentName }}）</b>
                  </el-col>
                  <el-col :span="6" class="tar">
                    <template v-if="activeName === 'second'">
                      <span v-if="item.communicationName">
                        <i class="el-icon-location mr-5" style="color: #999;"></i>
                        <span class="mr-10" style="color: #999;font-size: 12px;">{{ item.communicationName }}</span>
                      </span>
                      <span style="display: inline-block; width: 70px;">
                        <play-status type="error" v-if="item.changeResult === '未接通'">未接通</play-status>
                        <play-status type="warning" v-if="item.changeResult === '待定'">待定</play-status>
                        <play-status type="disabled" v-if="item.changeResult === '关闭名单'">关闭名单</play-status>
                        <play-status type="green" v-if="item.changeResult === '转线索'">转线索</play-status>
                        <!-- <play-status type="success" >{{ item.changeResult }}</play-status> -->
                      </span>
                    </template>
                    <template v-else>
                      <play-status type="error" v-if="item.callRecordInfo&&item.callRecordInfo.callStatus === '客户未接听'">客户未接听</play-status>
                      <play-status type="error" v-if="item.callRecordInfo&&item.callRecordInfo.callStatus === '坐席未接听'">坐席未接听</play-status>
                      <play-status type="success" v-if="item.callRecordInfo&&item.callRecordInfo.callStatus === '接通并回应'">接通并回应</play-status>
                      <!-- <play-status type="success" v-if="item.callRecordInfo">{{ item.callRecordInfo.callStatus }}</play-status> -->
                    </template>
                  </el-col>
                </el-row>
                <audioPlay v-if="item.callRecordInfo&&item.callRecordInfo.recordFile" ref="audioPlay" @reset2Audio="reset2Audio" :url="item.callRecordInfo.recordFile" />
                <el-row class="followUp_time">
                  <el-col :span="24" class="tal" v-if="activeName === 'second'">
                    <em>跟进情况</em>
                    <span class="max-tetx">{{ item.followResult||'--' }}</span>
                  </el-col>
                  <el-col :span="24" class="tar">
                    <template v-if="activeName === 'second'">
                      <span>跟进时间</span><span>{{ item.createAt||'--' }}</span>
                    </template>
                    <template v-if="activeName === 'third'">
                      <span>拨出时间</span><span>{{ item.callRecordInfo&&item.callRecordInfo.createAt||'--' }}</span>
                      <span>呼叫时长</span><span>{{ item.callRecordInfo&&item.callRecordInfo.totalDuration||'--' }}</span>
                      <span>通话时长</span><span>{{ item.callRecordInfo&&item.callRecordInfo.bridgeDuration||'--' }}</span>
                    </template>
                  </el-col>
                </el-row>
              </div>
            </div>
            <pagination :layout="'total, prev, pager, next, jumper'" class="tar" :pageNum="pageNum" :pageSize="pageSize" :total="total" @currentChange="handleCurrentChange"></pagination>
          </div>
        </div>
      </template>
    </el-drawer>
    <!-- 跟进 -->
    <followUpDialog ref="followUpDialog" @getData="getData" />
    <!-- 分配 -->
    <allotDialog ref="allotDialog" @getData="getData" />
    <!-- 激活 -->
    <activateDialog ref="activateDialog" @getData="getData" @closeDrawer="closeDrawer" />
    <!-- 打电话 -->
    <!-- <newCallFollowUpDialog ref="newCallFollowUpDialog" @getData="getData" @clickNextCall="clickNextCall" :isNext="isNext" /> -->
  </div>
</template>
<script>
import { getOptionConfigByType, dictList } from '@/api'
import { mapState } from 'vuex'
import { leadDetails, queryFollowRecordList, editLeadDetails } from '@/views/call/api'
import { debounce } from '@/base/global'
import followUpDialog from './followUpDialog'
import allotDialog from './allotDialog'
import activateDialog from './activateDialog'
import PlayStatus from './PlayStatus'

export default {
  components: { followUpDialog, PlayStatus, allotDialog, activateDialog },

  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  props: {
    isNext: { // 只有工作台有拨打下一通按钮
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    detailType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      pickerOptionsTime: {
        disabledDate: time => {
          return new Date(time) > new Date()
        }
      },
      total: 0,
      pageNum: 1,
      pageSize: 10,
      dataList: [],
      employeeCountList: [], // 规模
      industryList: [], // 行业
      roleList: [], // 角色
      mp3Url: 'http://ting6.yymp3.net:82/new27/chengxiang10/1.mp3',
      editKey: '',
      form: {},
      rowData: {},
      drawer: false,
      activeName: 'first',
      mobilePhoneOld: '', // 联系人手机号
      detail: {}
    }
  },
  beforeDestroy () {
    this.$bus.$off('callRefresh')
  },
  mounted () {
    // 外呼刷新
    this.$bus.$on('callRefresh', () => {
      if (this.drawer) this.getData()
    })
  },
  watch: {
  },
  computed: {
    // isAdmin() {
    //   return (this.$store.state.user.userRole && this.$store.state.user.userRole.admin) || (this.$store.state.user.userRole && this.$store.state.user.userRole.mainAccount)
    // },
    ...mapState({ areaData: state => state.user.area })
  },
  methods: {
    reset2Audio (url) {
      if (this.$refs.audioPlay && this.$refs.audioPlay.length) {
        this.$refs.audioPlay.forEach(e => {
          if (e.audioUrl !== url) {
            e.getPause()
          }
        })
      }
    },
    getCompanyName (val) {
      if (val) {
        if (val.length > 20) {
          var str = val.substring(0, 20) + '...'
          return str
        } else {
          return val
        }
      } else {
        return '--'
      }
    },
    getName (val) {
      if (val) {
        if (val.length > 10) {
          var str = val.substring(0, 10) + '...'
          return str
        } else {
          return val
        }
      } else {
        return '--'
      }
    },
    playAudio () { // 暂停录音
      if (this.$refs.audioPlay && this.$refs.audioPlay.length) {
        this.$refs.audioPlay.forEach(e => {
          if (e.$refs.recordAudio && e.$refs.recordAudio.paused) {
          } else {
            e.playAudio()
          }
        })
      }
    },
    // clickNextCall() {
    //   this.$emit('clickNextCall', this.rowData.id, 'details')
    // },
    handleClickCall: debounce(function () {
      this.playAudio()
      this.$bus.$emit('openFollowupBoard', { ...this.form, openType: 'details' })
      // this.$refs.newCallFollowUpDialog.openDialog(this.form)
    }, 400),
    getData () {
      this.$emit('getData')
      this.handleClick()
      this.leadDetails()
    },
    handleClick () {
      this.dataList = []
      if (this.activeName !== 'first') {
        this.pageNum = 1
        this.pageSize = 10
        this.queryFollowRecordList()
      }
      this.playAudio()
    },
    queryFollowRecordList () {
      var data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        leadId: this.rowData.id,
        isCallFollow: this.activeName === 'second' ? 0 : 1
      }
      queryFollowRecordList(data).then(res => {
        this.dataList = res.data.list
        this.total = Number(res.data.total)
      })
    },
    getList () {
      // getOptionConfigByType({ type: 2 }).then(res => { // 团队规模
      //   this.employeeCountList = res.data
      // })
      // getOptionConfigByType({ type: 1 }).then(res => { // 行业
      //   this.industryList = res.data
      // })
      // dictList(10).then(res => { // 角色
      //   this.roleList = [...res.data].map(item => { return { ...item, code: Number(item.code) } })
      // })
    },
    hasOne (data, id) {
      const index = data.findIndex(item => item.id === id)
      return index === -1 ? '' : id
    },
    handleCurrentChange (i) {
      this.pageNum = i
      this.queryFollowRecordList()
    },
    changeForm () {
      // 避免切换频繁调编辑接口  非input没有editKey
      // if (this.form[this.editKey] == this.detail[this.editKey]) {
      //   this.editKey = ''
      //   return
      // }

      var valid = false
      if (this.editKey === 'email') {
        if (this.form.email) {
          const reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
          if (!reg.test(this.form.email) || this.form.email.length < 6) {
            this.$message.warning('请填写正确的邮箱')
            valid = true
          }
        }
      }
      if (this.editKey === 'mobilePhone' || this.editKey === 'telephone') {
        if (!this.form.mobilePhone && !this.form.telephone) {
          valid = true
          this.$message.warning('联系人手机和电话不能同时为空')
        } else if (this.form.isEditMobilePhone === 0 && this.form.mobilePhone !== this.mobilePhoneOld) {
          this.form.mobilePhone = this.mobilePhoneOld
          this.$message.warning('渠道对接线索不允许修改号码')
        } else {
          if (this.form.mobilePhone && this.editKey === 'mobilePhone') {
            const reg = /1[3-9]\d{9}$/
            if (!reg.test(this.form.mobilePhone)) {
              this.$message.warning('请输入正确的手机号')
              valid = true
            }
          }
          if (this.form.telephone && this.editKey === 'telephone') {
            const reg = /0\d{2,3}[1-9]\d{6,7}|1[3-9]\d{9}/
            if (!reg.test(this.form.telephone) || this.form.telephone.includes('--')) {
              this.$message.warning('请输入正确的手机或座机，座机为“区号+号码”的纯数字，不加“-”')
              valid = true
            }
          }
        }
      }
      if (this.editKey === 'name' && !this.form.name) {
        this.$message.warning('联系人姓名不能为空')
        valid = true
      }

      if (valid) {
        this.editKey = ''
        this.leadDetails()
        return
      }
      if (this.form == {} || this.form == null || this.form.id == null) {
        return
      }
      editLeadDetails(this.form).then(res => {
        this.editKey = ''
        this.$emit('getData')
        this.leadDetails()
      }).catch(_ => {
        // 编辑有误回显
        this.leadDetails()
      })
    },
    clickIsEdit (key) {
      this.editKey = key
      // setTimeout(() => {
      this.$nextTick(() => {
        if (this.editKey.indexOf('demand') > -1) {
          this.$refs[key][0].focus()
        } else {
          this.$refs[key].focus()
        }
      })
      // }, 300)
    },
    clickActivate () { // 打开激活
      this.$refs.activateDialog.openDialog([this.rowData])
    },
    clickAllot () { // 打开分配
      this.$refs.allotDialog.openDialog([this.rowData])
    },
    clickFollow () { // 打开跟进
      this.$refs.followUpDialog.openDialog(this.rowData)
    },
    leadDetails (isNext) { // 获取详情
      leadDetails({ id: this.rowData.id }).then(res => {
        this.rowData.leadState = JSON.parse(JSON.stringify(res.data.leadState))
        res.data.teamSize = this.hasOne(this.employeeCountList, res.data.teamSize)
        res.data.industry = this.hasOne(this.industryList, res.data.industry)
        this.form = JSON.parse(JSON.stringify(res.data))
        this.detail = JSON.parse(JSON.stringify(res.data))
        this.mobilePhoneOld = res.data.mobilePhone
        // 点击【拨打下一通】后，从列表里拿当前通话数据的下一条，并打开跟进看板
        this.$nextTick(() => {
          if (isNext) {
            this.$bus.$emit('openFollowupBoard', { ...this.form, openType: 'details' })
            // this.$refs.newCallFollowUpDialog.openDialog(this.form)
          }
        })
      })
    },
    openDrawer (row, isNext) {
      this.form = {}
      this.dataList = []
      this.rowData = row
      this.activeName = 'first'
      this.getList()
      this.leadDetails(isNext)
      this.drawer = true
    },
    closeDrawer () {
      this.$emit('getData')
      this.drawer = false
      this.playAudio()
    }
  }
}
</script>
<style lang="scss" scoped>
.selection-fill .el-form-item__label:before {
  color: #1890ff;
}
/deep/.el-table {
  .el-table__row {
    .cell {
      color: #333;
    }
  }
}
.tal {
  text-align: left;
}
.tar {
  text-align: right;
}
.item-max {
  /deep/ .el-form-item__label {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.drawer_followUp {
  padding: 24px;
  background: #fbfbfb;
  .followUp_list {
    margin-bottom: 16px;
    p {
      color: #333;
    }
    .followUp_content {
      .followUp_title {
        margin-bottom: 16px;
        min-height: 40px;
        line-height: 40px;
        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          vertical-align: middle;
          margin-right: 10px;
        }
        b {
          font-size: 16px;
          color: #333;
          font-weight: 600;
        }
      }
      .followUp_time {
        .max-tetx {
          // position: relative;
          // top: 3px;
          display: inline-block;
          width: calc(100% - 75px);
          // overflow: hidden;
          // white-space: nowrap;
          // text-overflow: ellipsis;
          color: #333;
        }
        margin-top: 16px;
        em {
          float: left;
          color: #999999;
          margin-right: 10px;
        }
        span {
          color: #333333;
          margin-right: 10px;
        }
      }
      margin-top: 16px;
      padding: 16px;
      // height: 199px;
      background: #ffffff;
      box-shadow: 0px 4px 27px 0px rgba(0, 0, 0, 0.06);
      border-radius: 4px;
    }
  }
}
.mt-16 {
  margin-top: 16px;
}
.drawer_content {
  margin-bottom: 16px;
  background: #fff;
  padding: 24px;
  /deep/.el-form-item__label {
    text-align: left;
    color: #999;
  }
  .el-form-item,
  .el-col-12,
  .el-form-item__content {
    height: 40px !important;
    line-height: 40px !important;
    // margin-bottom: 6px;
  }
  .img-edit {
    float: left;
    margin-top: 12px;
    margin-left: 8px;
    cursor: pointer;
  }
  .span-edit {
    float: left;
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #333;
  }
  .el-input,
  .el-select,
  .el-cascader {
    width: 200px;
  }
  h2 {
    font-size: 16px;
    color: #303133;
    font-weight: 600;
    margin-bottom: 24px;
  }
}
.drawer_body {
  /deep/.el-tabs {
    .el-tabs__header {
      background: #fff;
      margin: 0;
    }
    .el-tabs__nav {
      left: 20px;
    }
  }
}
.drawer_header {
  background: #fff;
  // height: 160px;
  padding: 20px 24px;
  margin-bottom: 16px;
  > div {
    margin-bottom: 16px;
    b,
    span {
      font-size: 18px;
      color: #303133;
      margin-right: 10px;
    }
    img {
      width: 20px;
      height: 20px;
      position: relative;
      top: 3px;
    }
  }
  > p {
    span {
      color: #999;
      margin-right: 24px;
    }
    .play-status {
      margin-right: 42px;
    }
    em {
      color: #333;
    }
  }
}
/deep/.el-avatar,
/deep/.el-drawer {
  overflow: visible !important;
}
/deep/.drawer-wrap-detail {
  width: 960px !important;
  background: #f1f5f7;
  overflow: visible !important;
  .el-drawer__close-btn {
    position: absolute;
    top: 20px;
    left: -40px;
    width: 26px;
    height: 26px;
    border: 1px solid #ddd;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      color: #ddd;
    }
  }
  .el-drawer__body {
    overflow: auto;
  }
  .el-drawer__header {
    margin: 0;
    padding: 0;
  }
}
</style>
